module.exports = __webpack_public_path__ + "img/match_info.435138b1.png";